import { render } from "./MyTasksCard.vue?vue&type=template&id=b3aad79e&scoped=true"
import script from "./MyTasksCard.vue?vue&type=script&lang=js"
export * from "./MyTasksCard.vue?vue&type=script&lang=js"

import "@/assets/css/commandcenter/commandcenter.css?vue&type=style&index=0&lang=css&external"
import "./MyTasksCard.vue?vue&type=style&index=1&id=b3aad79e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3aad79e"]])

export default __exports__